// @flow
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

// Components
import StatusTrackerPage from './StatusTrackerPage';

// Selectors
import { getStatusTrackerData } from 'store/reducers/statusTracker/selectors';
import {
  getEmailReservationStatusSetting,
  getTextReservationStatusSetting
} from 'store/reducers/appointment/selectors';

// Actions
import { updateNotificationPreference } from 'store/reducers/statusTracker/actions';
import { setReservationStatusPrivacySettings } from 'store/reducers/appointment/actions';

const mapStateToProps = state => ({
  statusTrackerData: getStatusTrackerData(state),
  isEmailPrivacySettingOn: getEmailReservationStatusSetting(state),
  isTextPrivacySettingOn: getTextReservationStatusSetting(state)
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      updateNotificationPreference,
      setReservationStatusPrivacySettings
    },
    dispatch
  );

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(StatusTrackerPage);



// WEBPACK FOOTER //
// ./src/components/pages/StatusTrackerPage/StatusTrackerPageContainer.js